var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLightbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:#3c3f45;}.a{opacity:0;}.c{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.5,30v.016a.5.5,0,0,1-1,.031c0-.016,0-.031,0-.047v-.46a.5.5,0,0,1,1,0Z",
    transform: "translate(2 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,7.96a.5.5,0,0,1-.5-.5V7q0-.024,0-.047a.5.5,0,1,1,1,.031V7.46A.5.5,0,0,1,8,7.96Z",
    transform: "translate(2 2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.469,6.016A.5.5,0,0,1,8.953,5.5H9.44a.5.5,0,0,1,0,1H8.984A.5.5,0,0,1,8.469,6.016Z",
    transform: "translate(2 2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.469,30.984a.5.5,0,0,1,.515-.484H9.44a.5.5,0,0,1,0,1H8.953A.5.5,0,0,1,8.469,30.984Z",
    transform: "translate(2 -2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.06,31a.5.5,0,0,1,.5-.5h.456a.5.5,0,0,1,.031,1H30.56A.5.5,0,0,1,30.06,31Z",
    transform: "translate(-2 -2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.06,6a.5.5,0,0,1,.5-.5h.487a.5.5,0,0,1-.031,1H30.56A.5.5,0,0,1,30.06,6Z",
    transform: "translate(-2 2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.984,30.531a.5.5,0,0,1-.484-.515V29.54a.5.5,0,0,1,1,0V30c0,.016,0,.031,0,.047A.5.5,0,0,1,31.984,30.531Z",
    transform: "translate(-2 -2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.984,6.469a.5.5,0,0,1,.515.484c0,.016,0,.031,0,.047v.46a.5.5,0,0,1-1,0V6.984A.5.5,0,0,1,31.984,6.469Z",
    transform: "translate(-2 2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20,16.5A2.5,2.5,0,1,1,17.5,19,2.5,2.5,0,0,1,20,16.5Zm0,1A1.5,1.5,0,1,1,18.5,19,1.5,1.5,0,0,1,20,17.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.5,19.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,19a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,0-1h-2A.5.5,0,0,0,13,19Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.5,14.5a.5.5,0,0,1-1,0v-2a.5.5,0,0,1,1,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20,26a.5.5,0,0,0,.5-.5v-2a.5.5,0,0,0-1,0v2A.5.5,0,0,0,20,26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.535,16.171a.5.5,0,0,1-.707-.707l1.414-1.414a.5.5,0,1,1,.707.707Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.05,23.95a.5.5,0,0,0,.707,0l1.414-1.414a.5.5,0,1,0-.707-.707L15.05,23.243A.5.5,0,0,0,15.05,23.95Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.828,22.536a.5.5,0,0,1,.707-.707l1.414,1.414a.5.5,0,0,1-.707.707Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.05,14.05a.5.5,0,0,0,0,.707l1.414,1.414a.5.5,0,1,0,.707-.707L15.757,14.05A.5.5,0,0,0,15.05,14.05Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6,31.5a.5.5,0,0,0-.5.5v3a.5.5,0,0,1-1,0V32A1.5,1.5,0,0,1,6,30.5H7.5V7A1.5,1.5,0,0,1,9,5.5H31A1.5,1.5,0,0,1,32.5,7V30.5H34A1.5,1.5,0,0,1,35.5,32v3a.5.5,0,0,1-1,0V32a.5.5,0,0,0-.5-.5Zm25.5-1V7a.5.5,0,0,0-.5-.5H9a.5.5,0,0,0-.5.5V30.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightbox);
export default __webpack_public_path__ + "static/media/icon-lightbox.60ceead3.svg";
export { ForwardRef as ReactComponent };